import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["overflow", "tabBarMargin", "animated", "numbered", "className", "children"],
  _excluded2 = ["className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Tabs } from 'antd';
import classNames from 'classnames';
import { DixuTextArea } from "../DixuInput/DixuInput";
import DixuText from "../DixuText/DixuText";
import React from 'react';
const DixuTabs = _ref => {
  let {
      overflow,
      tabBarMargin,
      animated,
      numbered,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-tabs', {
    'dixu-tabs--no-tab-bar-margin': !tabBarMargin,
    'dixu-tabs--allow-overflow': typeof overflow === 'undefined' ? typeof animated === 'object' ? !animated.tabPane : animated : overflow
  }, className);
  const mappedChildren = (() => {
    const mapped = [];
    React.Children.forEach(children, (child, index) => {
      const {
        props
      } = child || {};
      const {
        tab
      } = props || {};
      if (numbered && tab) {
        const cloned = /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
          tab: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
            className: "dixu-tabs__tab-number"
          }, index + 1), tab)
        }));
        mapped.push(cloned);
        return;
      }
      mapped.push(child);
    });
    return mapped;
  })();
  return /*#__PURE__*/React.createElement(Tabs, _objectSpread({
    className: classes,
    animated
  }, rest), mappedChildren);
};
DixuTabs.defaultProps = {
  overflow: undefined,
  tabBarMargin: true,
  numbered: false,
  animated: {
    inkBar: true,
    tabPane: false
  }
};
const DixuTabPane = _ref2 => {
  let {
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-tab-pane', className);
  return /*#__PURE__*/React.createElement(Tabs.TabPane, _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuText, {
    weight: "medium"
  }, children));
};
DixuTabPane.defaultProps = {};
DixuTabs.TabPane = DixuTabPane;
export default DixuTabs;